import React from 'react';
import {
  Card,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';

const CountProject = React.memo(({ data }) => {

  const progress = 100; // cercle complet
  // Fonction pour créer un cercle
  const StatCircle = ({ label, value ,color}) => (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        variant="determinate"
        value={progress}
        size={140}
        thickness={5}
        sx={{ color: color }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography
          variant="body2"
          sx={{ color: '#555555', fontWeight: 'bold', fontSize: '1.1rem' }}
        >
          {label}
        </Typography>
        <Typography
          variant="h6"
          component="div"
          sx={{ color: '#222222', fontWeight: 'bold', fontSize: '1rem' }}
        >
          {value ?? 0}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Card sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: 3 }}>
   <Box display="flex" flexDirection="row" gap={10}>
        <StatCircle label="Total" value={data.total} color="#4a7bbd"/>
        <StatCircle label="Actif" value={data.active} color="#43a047"/>
        <StatCircle label="Archivé" value={data.archived} color="#e53935"/>
       </Box>
    </Card>
  );
});

export default CountProject;
